<template>
  <div class="c-creative">
    <div class="header">
      <div class="item-label">创意样式({{ len }}/{{ max }})</div>

      <RadioGroup v-model="creativeType" type="button">
        <Radio :label="1">竖版视频{{ verticaLen ? `(${verticaLen})` : '' }}</Radio>
        <Radio :label="2">横版视频{{ horizontaLen ? `(${horizontaLen})` : '' }}</Radio>
      </RadioGroup>
    </div>

    <div class="creative-items">
      <div class="c-idea-bar">
        <div class="c-idea-content">
          <template v-for="(c, i) in creativeData">
            <div :key="c.id" :class="classes(i)" @click.stop="current = i">
              <span>创意{{ i + 1 }}</span>
              <span class="m-remove" @click.stop="delCreative(c.id, i)"></span>
            </div>
          </template>
        </div>
        <Button :disabled="len === max" type="primary" icon="md-add" @click="multipleSelect">添加创意</Button>
      </div>
      <div class="c-creative-wrapper g-clearfix">
        <div v-for="(item, id) in tempalteJson" :key="id" :class="creativeClasses(item)">
          <creat-image
            v-if="item.element === 'ELEMENT_TYPE_IMAGE'"
            v-model="item[item.name]"
            :name="item.name"
            :mode="item.element"
            :width="item.restriction.width"
            :height="item.restriction.height"
            :size="item.restriction.file_size"
            :format="item.restriction.file_format"
            :required="item.required"
            :description="item.description"
            :verify="verify"
            :source="source"
            :scene-id="sceneId"
            :loading="imageLoading"
            @change="$emit('off')"
            @select="selectMedia"
            @upload="uploadFileComplet"
            @set-loading="imageLoading = $event"
          />
          <creat-video
            v-if="item.element === 'ELEMENT_TYPE_VIDEO'"
            v-model="item[item.name]"
            :name="item.name"
            :mode="item.element"
            :width="item.restriction.width"
            :height="item.restriction.height"
            :size="item.restriction.file_size"
            :format="item.restriction.file_format"
            :required="item.required"
            :description="item.description"
            :verify="verify"
            :source="source"
            :scene-id="sceneId"
            @change="$emit('off')"
            @select="selectMedia"
            @upload="uploadFileComplet"
          />
          <creat-image
            v-if="item.element === 'ELEMENT_TYPE_COVER'"
            v-model="item[item.name]"
            :name="item.name"
            :mode="item.element"
            :width="item.restriction.width"
            :height="item.restriction.height"
            :size="item.restriction.file_size"
            :format="item.restriction.file_format"
            :required="item.required"
            :description="item.description"
            :verify="verify"
            :source="source"
            :scene-id="sceneId"
            @change="$emit('off')"
            @select="selectMedia"
            @upload="uploadFileComplet"
          />
          <creat-title
            v-if="item.element === 'ELEMENT_TYPE_TEXTAREA'"
            v-model="item[item.name]"
            :name="item.name"
            :words="words"
            :min="item.restriction.min_length"
            :max="item.restriction.max_length"
            :required="item.required"
            :description="item.description"
            :verify="verify"
            @change="$emit('off')"
          />
          <creat-button
            v-if="item.element === 'ELEMENT_TYPE_ENUM'"
            v-model="item[item.name]"
            :name="item.name"
            :enumeration="item.restriction.enumeration"
            :default-value="item.restriction.default"
            :required="item.required"
            :description="item.description"
            :verify="verify"
            @change="$emit('off')"
          />
          <creat-mult-select
            v-if="item.element === 'ELEMENT_TYPE_ENUMS'"
            v-model="item[item.name]"
            :name="item.name"
            :enumeration="item.restriction.enumeration"
            :default-value="item.restriction.default"
            :required="item.required"
            :description="item.description"
            :verify="verify"
            @change="$emit('off')"
          />
          <!-- && sceneId !== 5 -->
          <creat-title
            v-if="item.element === 'ELEMENT_TYPE_SLOG'"
            v-model="item[item.name]"
            :name="item.name"
            :words="words"
            :min="item.restriction.min_length"
            :max="item.restriction.max_length"
            :required="item.required || hasStick"
            :description="item.description"
            :verify="verify"
            @change="$emit('off')"
          />
          <!-- && sceneId !== 5 -->
          <creat-stick
            v-if="item.element === 'ELEMENT_TYPE_STICK'"
            v-model="item[item.name]"
            :name="item.name"
            :enumeration="item.restriction.enumeration"
            :default-value="item.restriction.default"
            :required="item.required || hasStick"
            :description="item.description"
            :verify="verify"
            @change="$emit('off')"
          />
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="showSelectorModal"
      custom-class="material-selector-dialog"
      :close-on-click-modal="false"
      title="选择素材"
      width="1200px"
      append-to-body
    >
      <AssetsSelector
        v-bind="{ ...selectorProps, visible: showSelectorModal, selectedGameId: gameId }"
        @close="showSelectorModal = false"
        @confirm="uploadFileHandle"
      >
        <template v-slot:assetType="{ getData }">
          <el-radio
            v-model="selectorProps.assetType"
            :disabled="seletedMaterialRadioDiasbled[MATERIAL_TYPE.VIDEO]"
            @change="getData"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.VIDEO]"
          >
            视频
          </el-radio>
          <el-radio
            v-model="selectorProps.assetType"
            :disabled="seletedMaterialRadioDiasbled[MATERIAL_TYPE.IMAGE]"
            @change="getData"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE]"
          >
            图片
          </el-radio>
          <el-radio
            v-model="selectorProps.assetType"
            :disabled="seletedMaterialRadioDiasbled.cover"
            @change="getData"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.POSTER]"
          >
            封面
          </el-radio>
        </template>

        <template v-slot:sizes="{ getData, width }">
          <el-select
            :style="{ width }"
            popper-class="creative-selector-el-select-popper"
            :popper-append-to-body="false"
            v-model="selectorProps.form.sizes"
            clearable
            multiple
            collapse-tags
            @change="getData"
          >
            <!-- 根据当前选择素材的类型来获取尺寸下拉数据 -->
            <el-option
              v-for="item in MATERIAL_TYPE_SIZES[selectorProps.assetType]"
              :key="item.label"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </template>
      </AssetsSelector>
    </el-dialog>
  </div>
</template>
<script>
import { isEmpty } from '@/common/js/utils'
import mixinUpload from './mixin-upload'

import CreatImage from './creat-image'
import CreatVideo from './creat-video.vue'
import CreatTitle from './creat-title'
import CreatButton from './creat-button'
import CreatStick from './creat-stick'
import CreatMultSelect from './creat-mult-select'
import { MATERIAL_TYPE_ID, MATERIAL_TYPE } from '@/components/material-selector/consts.js'
export default {
  name: 'Creative',
  mixins: [mixinUpload],
  components: { CreatImage, CreatVideo, CreatTitle, CreatButton, CreatStick, CreatMultSelect },
  props: {
    data: {
      type: Array,
      required: true
    },
    max: {
      type: Number,
      default: 5
    },
    sceneId: {
      type: Number,
      default: 1
    },
    media: {
      type: [String, Number]
    },
    source: {
      type: Array,
      default() {
        return []
      }
    },
    words: {
      type: Array
    },
    verify: {
      type: Boolean,
      default: false
    },
    gameId: {
      type: [String, Number],
      default: 0
    },
    openId: {
      type: [String, Number],
      default: ''
    },
    gameData: {
      type: Array
    },
    gameGroupData: {
      type: Array
    },
    operatorData: {
      type: Array
    },
    labelData: {
      type: Array
    }
  },
  computed: {
    len() {
      return this.data.length
    },
    creativeData() {
      return this.data.filter((ret) => ret.creative_material_type === this.creativeType)
    },
    horizontaLen() {
      return this.data.filter((ret) => ret.creative_material_type === 2).length
    },
    verticaLen() {
      return this.data.filter((ret) => ret.creative_material_type === 1).length
    },
    tempalteJson() {
      return this.creativeData[this.current] && this.creativeData[this.current].template ? this.creativeData[this.current].template : []
    },
    classes() {
      return (item) => {
        return [
          'm-creative-btn',
          {
            'm-current': item === this.current
          }
        ]
      }
    },
    creativeClasses() {
      return (item) => {
        let cls = ''
        if (item.element === 'ELEMENT_TYPE_VIDEO') cls = 'c-creative-video'
        else if (item.element === 'ELEMENT_TYPE_COVER') cls = 'c-creative-cover'
        else cls = 'c-creative-media'
        return [cls]
      }
    },
    hasStick() {
      return this.tempalteJson.some((ret) => !isEmpty(ret.overlay_type) || !isEmpty(ret.sticker_title))
    }
  },
  data() {
    return {
      current: 0,
      creativeType: 1
    }
  },
  methods: {
    getCaohuaVideoId() {
      let id = ''
      const index = this.tempalteJson.findIndex((ret) => ret.element === 'ELEMENT_TYPE_VIDEO')
      if (index > -1) id = this.tempalteJson[index][this.tempalteJson[index].name]
      return id
    },
    selectMedia(params) {
      const { name, type, width, height, size } = params
      const uploadType = this.switchToType(type)
      const detailId = this.getCaohuaVideoId()
      this.uploadBatch = null
      this.uploadSmart = 0
      // if (uploadType === 'cover' && detailId) this.uploadSmart = detailId
      this.uploadType = uploadType
      this.uploadWidth = width
      this.uploadHeight = height
      // this.uploadModel = true
      this.uploadMult = 1
      this.uploadName = name
      this.uploadSize = size
      this.isReplaceMode = true

      let assetType = uploadType
      if (uploadType === 'cover' && detailId) {
        this.uploadSmart = detailId
        this.selectorProps.videoId = detailId
        assetType = 'poster'
      }
      this.selectorProps.form = this.getInitSelectorForm()
      this.selectorProps.form.sizes = [`${width}*${height}`]
      this.selectorProps.assetType = MATERIAL_TYPE_ID[assetType]
      this.selectorProps.max = this.uploadMult
      this.showSelectorModal = true
    },
    delCreative(id, index) {
      this.$emit('on-splice', { id, type: 'del', mode: this.creativeType })
      if (index && this.current === index) this.current = index - 1
    }
  },
  watch: {
    creativeType() {
      this.current = 0
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~common/styles/element-ui/variables.scss';

.c-creative {
  position: relative;
  width: 100%;

  .header {
    display: flex;
    align-items: center;
    .item-label {
      width: 146px;
      font-size: 14px;
      padding-right: 10px;
      text-align: right;
    }
  }
  .creative-items {
    margin-left: 146px;
  }

  .c-idea {
    overflow-x: auto;
    width: 100%;
  }

  .c-idea-bar {
    position: relative;
    padding: 10px 0;

    .c-idea-content {
      display: inline-block;

      .m-creative-btn {
        border-radius: 4px;
        border: solid 1px #efefef;
        position: relative;
        display: inline-block;
        line-height: 32px;
        padding: 0 12px;
        margin-right: 12px;
        margin-bottom: 12px;
        user-select: none;
        cursor: pointer;

        .m-remove {
          position: absolute;
          color: #fff;
          width: 12px;
          height: 12px;
          line-height: 12px;
          font-size: 60%;
          border-radius: 9px;
          background-color: #ff635c;
          text-align: center;
          display: block;
          z-index: 11;
          top: -6px;
          right: -3px;
          transition: display 0.2s ease-in-out;

          &:before {
            content: 'x';
            display: inline-block;
            position: absolute;
            top: -2px;
            left: 3px;
            transform: scale(0.9);
          }
        }
      }

      .m-current {
        color: #ffffff;
        border-color: $primary-color;
        background-color: $primary-color;
      }
    }
  }

  .c-creative-wrapper {
    max-width: 580px;
    position: relative;
    padding-bottom: 12px;

    .c-creative-media {
      margin-top: 12px;
      display: block;

      &:first-child {
        margin-top: 0;
      }
    }

    .c-creative-video,
    .c-creative-cover {
      display: inline-block;
    }

    .c-creative-video {
      margin-right: 8px;
    }

    ::v-deep .ant-select {
      width: 100%;
    }
  }
}
</style>
